import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guards/auth.guard';
import {NoLogementGuard} from './guards/no-logement-guard.service';
import {UpdatableGuard} from './guards/updatable.guard';
import {ProprietaireGuard} from "./guards/proprietaire.guard";
import {sonergiaGuard} from "./guards/sonergia-guard.service";
import {PartnerGuard} from "./guards/partner-guard.service";

const routes: Routes = [
  {
    path: 'accueil',
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'mon-compte',
    loadChildren: () => import('./pages/compte/compte.module').then(m => m.CompteModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'conseils',
    loadChildren: () => import('./pages/conseils/conseils.module').then(m => m.ConseilsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'annonces',
    loadChildren: () => import('./pages/annonces/annonces.module').then(m => m.AnnoncesModule),
    canActivate: [AuthGuard, PartnerGuard]
  },
  {
    path: 'actualites',
    loadChildren: () => import('./pages/actualites/actualites.module').then(m => m.ActualitesModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'contacts',
    loadChildren: () => import('./pages/contacts/contacts.module').then(m => m.ContactsModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'mes-equipements',
    loadChildren: () => import('./pages/equipements/equipements.module').then(m => m.EquipementsModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'equipement/:id',
    loadChildren: () => import('./pages/equipement/equipement-page.module').then(m => m.EquipementPageModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'equipement-global/:id',
    loadChildren: () => import('./pages/equipement-global/equipement-global-page.module').then(m => m.EquipementGlobalPageModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'actions',
    loadChildren: () => import('./pages/actions/actions.module').then(m => m.ActionsModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'documents',
    loadChildren: () => import('./pages/documents/documents.module').then(m => m.DocumentsModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'mes-documents/:id',
    loadChildren: () => import('./pages/documents/documents.module').then(m => m.DocumentsModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'mon-logement',
    loadChildren: () => import('./pages/mon-logement/view/view.module').then(m => m.ViewModule),
    canActivate: [AuthGuard, NoLogementGuard]
  },
  {
    path: 'mon-logement/edit',
    loadChildren: () => import('./pages/mon-logement/edit/edit.module').then(m => m.EditModule),
    canActivate: [AuthGuard, NoLogementGuard, UpdatableGuard, ProprietaireGuard]
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then(m => m.NotificationsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mes-logements',
    loadChildren: () => import('./pages/mes-logements/mes-logements.module').then(m => m.MesLogementsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'infos-generales',
    loadChildren: () => import('./pages/infos-generales/infos-generales.module').then(m => m.InfosGeneralesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'travaux',
    loadChildren: () => import('./pages/travaux/travaux.module').then(m => m.TravauxModule),
    canActivate: [AuthGuard, sonergiaGuard]
  },
  {
    path: 'infos-generales/mentions-legales',
    loadChildren: () => import('./pages/page/page.module').then(m => m.PageModule),
    canActivate: [AuthGuard],
    data: {
      slug: 'mentions-legales'
    }
  },
  {
    path: 'infos-generales/qui-sommes-nous',
    loadChildren: () => import('./pages/page/page.module').then(m => m.PageModule),
    canActivate: [AuthGuard],
    data: {
      slug: 'qui-sommes-nous'
    }
  },
  {
    path: 'infos-generales/partenariat',
    loadChildren: () => import('./pages/partner-infos-generales/partner-infos-generales.module').then(m => m.PartnerInfosGeneralesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'infos-generales/nos-activites',
    loadChildren: () => import('./pages/page/page.module').then(m => m.PageModule),
    canActivate: [AuthGuard],
    data: {
      slug: 'nos-activites'
    }
  },
  {
    path: 'infos-generales/cgu',
    loadChildren: () => import('./pages/page/page.module').then(m => m.PageModule),
    canActivate: [AuthGuard],
    data: {
      slug: 'cgu'
    }
  },
  {
    path: 'rt2012',
    loadChildren: () => import('./pages/rt2012/rt2012.module').then(m => m.Rt2012Module),
    canActivate: [AuthGuard],
  },
  {
    path: 'mes-locataires',
    loadChildren: () => import('./pages/mes-locataires/mes-locataires.module').then(m => m.MesLocatairesModule),
    canActivate: [AuthGuard, ProprietaireGuard]
  },
  {
    path: 'changement-proprietaire/:id',
    loadChildren: () => import('./pages/changement-proprietaire/changement-proprietaire.module').then(m => m.ChangementProprietaireModule),
    canActivate: [AuthGuard, ProprietaireGuard]
  },
  {
    path: 'comparaison',
    loadChildren: () => import('./pages/consumption/consumption.module').then(m => m.ConsumptionModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'version',
    loadChildren: () => import('./pages/git-version/git-version.module').then(m => m.GitVersionModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'partage-document',
    loadChildren: () => import('./pages/partage-document/view/partage-document-view.module').then(m => m.PartageDocumentModule),
    canActivate: [AuthGuard, ProprietaireGuard]
  },
  {
    path: 'parcours-travaux',
    loadChildren: () => import('./pages/parcours-travaux/parcours-travaux.module').then(m => m.ParcoursTravauxModule),
    canActivate: []
  },

  {path: '**', redirectTo: 'accueil', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
